import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'

type optionsType = ReactQueryOptions['ToyManager']['getModelAdmin']
type inputType = RouterInputs['ToyManager']['getModelAdmin']

export const useGetModelAdmin = (input: inputType, options?: optionsType) =>
    api.ToyManager.getModelAdmin.useQuery(input, {
        ...options,
        queryKey: ['ToyManager.getModelAdmin', input],
        staleTime: 60 * 60 * 1000 * staleTimeIndex, // 1 hour
    })
